export {VscodeTabHeader} from './vscode-tab-header.js';
